/** axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'
import { Message, Loading } from 'element-ui'
import { requestParamsFormat } from 'baiyihui-plugins'
import router from '../router/index'
import base from '../api/base'

// 跳转登录页面
function redirectLogin() {
  // 账号登录异常 (token过期或是账号其他端登录)
  // 清除 localStorage所有数据
  localStorage.clear()
  sessionStorage.clear()
  router.currentRoute.path !== '/login' && router.push({ path: '/login' })
}

// 页面找不到，跳转404页面
function backPageHome() {
  router.replace({ path: '*' })
}

let loading // 定义loading变量
function startLoading() { // 使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.4)'
  })
}

function endLoading() { // 使用Element loading-close 方法
  loading.close()
}

let needLoadingRequestCount = 0
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

// 请求拦截器
axios.interceptors.request.use(
  config => {
    if (config.loading) {
      showFullScreenLoading()
    }

    requestParamsFormat(config)
    // 注册的用户信息存储localStorage
    let userInfo = localStorage.getItem('userInfo')
    const loginIdent = localStorage.getItem('LOGIN_IDENT') || 'DRUGSTORE_ADMINISTRATORS'

    let token = ''
    config.headers['token'] = token
    config.headers['appCode'] = base.appCode
    config.headers['ident'] = loginIdent
    if (userInfo) {
      userInfo = JSON.parse(userInfo)
      token = userInfo.token
      config.headers['token'] = token
    }
    return config
  },
  error => {
    tryHideFullScreenLoading()
    Message.error({
      message: '请求超时!'
    })
    return Promise.resolve(error)
  }
)

// 响应拦截
axios.interceptors.response.use(res => {
  if (res.config.loading) {
    tryHideFullScreenLoading()
  }
  if (res.config.responseType === 'blob' || res.config.url.includes('/api/manage/drugItem/js/import')) {
    return res
  }
  switch (res.data.code) {
    case '1':
      return res.data
    case '0':
      Message.error({
        message: res.data.msg
      })
      return Promise.reject(res)
    case '1110001':
      Message.closeAll()
      Message.error({
        message: res.data.msg
      })
      redirectLogin()
      return Promise.reject(res)
    case '1140004':
      backPageHome()
      return Promise.reject(res)
    case 200:
      return res.data
    case 201:
      Message.error({
        message: res.data.msg
      })
      return Promise.reject(res)
    case 202:
      Message.error({
        message: '服务器异常，请稍后重试'
      })
      return Promise.reject(res)
    case 500:
      Message.error({
        message: '服务器异常，请稍后重试'
      })
      break
    default:
      return Promise.reject(res)
  }
}, err => {
  tryHideFullScreenLoading()
  if (!err.response.status) {
    Message.error({
      message: '服务器异常，请稍后重试'
    })
    return false
  }
  switch (err.response.status) {
    case 500:
      Message.error({
        message: '服务器异常，请稍后重试'
      })
      break
    case 504:
      Message.error({
        message: '服务器异常，请稍后重试'
      })
      break
    case 1110001:
      Message.closeAll()
      Message.error({
        message: err.data.msg
      })
      redirectLogin()
      return Promise.reject(err)
    case 404:
      Message.error({
        message: '服务器异常，请稍后重试'
      })
      break
    case 403:
      Message.error({
        message: '权限不足,请联系管理员!'
      })
      break
    default:
      return Promise.reject(err)
  }
})
axios.defaults.timeout = 300000 // 请求超时5fen
export const postJsonRequest = (url, params, sign, loading = true) => {
  if (!sign) {
    sign = ''
  }
  return axios({
    method: 'post',
    url: url,
    data: params,
    loading: loading,
    headers: {
      'Content-Type': 'application/json',
      sign
    }
  })
}
export const postRequest = (url, params, loading = true) => {
  return axios({
    method: 'post',
    url: url,
    data: params,
    loading: loading,
    transformRequest: [function(data) {
      let ret = ''
      for (const it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export const postHTMLRequest = (url, params, loading = true) => {
  return axios({
    method: 'post',
    dataType: 'html',
    url: url,
    data: params,
    loading: loading,
    transformRequest: [function(data) {
      let ret = ''
      for (const it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      console.log(ret)
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export const postFormRequest = (url, params, loading = true) => {
  return axios({
    method: 'post',
    url: url,
    data: params,
    loading: loading,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export const getRequest = (url, data = {}, loading = true) => {
  return axios({
    method: 'get',
    params: data,
    url: url,
    loading: loading
  })
}
export const blobRequest = (url, params, loading = true) => {
  return axios({
    method: 'post',
    url: url,
    params: params,
    cancelToken: '',
    responseType: 'blob',
    loading: loading,
    transformRequest: [function(data) {
      let ret = ''
      for (const it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      console.log(ret)
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export const blobJsonRequest = (url, params, sign, loading = true) => {
  if (!sign) {
    sign = ''
  }
  return axios({
    method: 'post',
    url: url,
    data: params,
    responseType: 'blob',
    loading: loading,
    headers: {
      'Content-Type': 'application/json',
      sign
    }
  })
}
export const blobGetRequest = (url, params, loading = true) => {
  return axios({
    method: 'get',
    url: url,
    params: params,
    cancelToken: '',
    loading: loading,
    responseType: 'blob'
  })
}



// WEBPACK FOOTER //
// ./src/utils/request.js